import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import type {ProposedChangeNoticeProps} from './proposed-change-notice.types';
import {PROPOSED_CHANGE_NOTICE_ICON, ProposedChangeNoticeTone} from './proposed-change-notice.types';
import styles from './proposed-change-notice.module.scss';

/** An error is announced as an alert; a warning sits in the chat's polite log, which announces it when it appears. */
export function ProposedChangeNotice({tone, text}: ProposedChangeNoticeProps): ReactElement {
  const isError = tone === ProposedChangeNoticeTone.ERROR;

  return (
    <div className={`${styles.proposedChangeNotice} ${isError ? styles.proposedChangeNoticeError : styles.proposedChangeNoticeWarning}`} role={isError ? 'alert' : undefined}>
      <Icon icon={PROPOSED_CHANGE_NOTICE_ICON[tone]} size={IconSize.SIZE_ICON_16} className={styles.proposedChangeNoticeIcon} ariaHidden />
      <Text val={text} size={TextSize.SM} className={styles.proposedChangeNoticeText} />
    </div>
  );
}
